module.exports.DEFAULT_ENDPOINT = 'https://api.mapbox.com';